(() => {
  'use strict';
  const normalise = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/&(?:amp;)?/g, ' and ').replace(/[’']/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  function relevance(product, query) {
    const q = normalise(query);
    if (!q) return 1;
    const title = normalise(product.title);
    const perfume = normalise(product.perfume);
    const inspiration = normalise(product.inspiration);
    const brand = normalise(product.brand);
    const primary = `${title} ${inspiration} ${brand}`;
    if (title === q || perfume === q || inspiration === q) return 1000;
    if (title.startsWith(q) || perfume.startsWith(q) || inspiration.startsWith(q)) return 900;
    const words = q.split(' ');
    const tokens = primary.split(' ');
    if (words.every(word => tokens.some(token => token.startsWith(word)))) return brand === q ? 850 : 800;
    const notes = normalise([product.notes,product.family,product.scent_style,...(product.tags || [])].join(' '));
    if (words.every(word => `${primary} ${notes}`.split(' ').some(token => token.startsWith(word)))) return 300;
    return 0;
  }
  const catalogueNode = document.getElementById('FRSearchCatalogue');
  const labelsNode = document.getElementById('FRSearchLabels');
  if (!catalogueNode || !labelsNode) return;
  let products, labels;
  try { products = JSON.parse(catalogueNode.textContent).map(product => ({...product,brand:({'inito parfums':'Initio Parfums Privés','killian':'Kilian','nasmatto':'Nasomatto','parfums de marley':'Parfums de Marly'}[normalise(product.brand)] || product.brand)})); labels = JSON.parse(labelsNode.textContent); } catch { return; }
  window.FRFragranceSearch = { products, score: relevance };
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:'GBP',maximumFractionDigits:2});
  const ranked = query => products.map(product => ({product,score:relevance(product,query)})).filter(item => item.score > 0).sort((a,b) => b.score-a.score || Number(b.product.available)-Number(a.product.available) || a.product.title.localeCompare(b.product.title));
  const escape = value => String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  let sequence = 0;
  function setupAutocomplete(form, component) {
    if (form.dataset.frAutocomplete === 'true') return;
    const input = form.querySelector('input[type="search"]');
    if (!input) return;
    form.dataset.frAutocomplete = 'true';
    const id = `FRSuggestions-${++sequence}`;
    let panel = component?.predictiveSearchResults || component?.querySelector('.search__results');
    if (!panel) { panel = document.createElement('div'); form.append(panel); }
    panel.id = id;
    panel.classList.add('fr-search-suggestions');
    panel.setAttribute('role','listbox');
    panel.setAttribute('aria-label',input.getAttribute('placeholder') || 'Search');
    input.setAttribute('role','combobox'); input.setAttribute('aria-autocomplete','list'); input.setAttribute('aria-expanded','false'); input.setAttribute('aria-controls',id); input.setAttribute('aria-owns',id);
    input.setAttribute('autocomplete','off');
    let active = -1;
    function close() { panel.style.display='none'; input.setAttribute('aria-expanded','false'); input.removeAttribute('aria-activedescendant'); active=-1; if(component) component.classList.remove('is-active'); }
    function render() {
      const query = input.value.trim();
      if (!query) { panel.replaceChildren(); close(); return; }
      const matches = ranked(query).slice(0,6);
      panel.innerHTML = matches.map(({product},index) => `<a class="fr-search-suggestion" id="${id}-${index}" role="option" aria-selected="false" href="${escape(product.url)}"><img src="${escape(product.image)}" width="64" height="64" alt=""><span><strong>${escape(product.title)}</strong><span>${escape(labels.inspired)} <b>${escape(product.inspiration)}</b></span><small>${escape(labels.from.replace('[price]',money.format(product.price/100)))}</small></span></a>`).join('');
      if (!matches.length) { const empty=document.createElement('p'); empty.className='fr-search-suggestions__empty';empty.textContent=labels.empty;panel.append(empty); }
      const all=document.createElement('a');all.className='fr-search-suggestions__all';all.href=`${form.action}?q=${encodeURIComponent(query)}&type=product`;all.textContent=labels.all.replace('[query]',query);panel.append(all);
      panel.style.display='block';input.setAttribute('aria-expanded','true');input.removeAttribute('aria-activedescendant');active=-1;
      if(component) component.classList.add('is-active');
    }
    input.addEventListener('input',render);
    input.addEventListener('focus',()=> {if(input.value.trim()) render();});
    input.addEventListener('keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();close();return;}
      const options=Array.from(panel.querySelectorAll('[role="option"]'));
      if((event.key==='ArrowDown'||event.key==='ArrowUp') && options.length){event.preventDefault();active=(active+(event.key==='ArrowDown'?1:-1)+options.length)%options.length;options.forEach((option,i)=>option.setAttribute('aria-selected',String(i===active)));input.setAttribute('aria-activedescendant',options[active].id);options[active].scrollIntoView({block:'nearest'});}
      if(event.key==='Enter' && active>=0 && options[active]){event.preventDefault();options[active].click();}
    });
    form.addEventListener('focusout',()=>setTimeout(()=>{if(!form.contains(document.activeElement)) close();},0));
    document.addEventListener('pointerdown',event=>{if(!form.contains(event.target)) close();});
    component?.querySelector('.btn--close-search')?.addEventListener('click',close);
    component?.querySelector('[data-screen]')?.addEventListener('click',close);
    if(component){component.getSearchResults=render;component.onChange=()=>{};}
  }
  function setupResults(root) {
    if (root.dataset.frReady) return;
    root.dataset.frReady = 'true';
    const form = root.querySelector('[data-fr-results-form]');
    const input = form.querySelector('input[type="search"]');
    const grid = root.querySelector('[data-fr-results-grid]');
    const count = root.querySelector('[data-fr-results-count]');
    const empty = root.querySelector('[data-fr-results-empty]');
    const sort = root.querySelector('[data-fr-results-sort]');
    const filters = Array.from(root.querySelectorAll('[data-fr-results-filter]'));
    const pageLabels = JSON.parse(root.querySelector('[data-fr-page-labels]').textContent);
    const cards = new Map(Array.from(grid.querySelectorAll('[data-fr-result]')).map(element => {
      const profile = element.querySelector('[data-fr-scent]');
      return [element.dataset.frResult, {element, scent:profile?.dataset.frScent || '', character:profile?.dataset.frCharacter || '', occasion:profile?.dataset.frOccasion || ''}];
    }));
    const brand = filters.find(select => select.dataset.frResultsFilter === 'brand');
    Array.from(new Set(products.filter(p => cards.has(p.handle)).map(p => p.brand).filter(Boolean))).sort().forEach(value => {
      const option = document.createElement('option'); option.value = value; option.textContent = value; brand.append(option);
    });
    const chips = root.querySelector('[data-fr-active-filters]');
    const dialog = root.querySelector('[data-fr-refine-dialog]');
    const trigger = root.querySelector('[data-fr-refine-open]');
    const controls = root.querySelector('[data-fr-filter-controls]');
    const controlsParent = controls.parentNode;
    const mobile = matchMedia('(max-width:749px)');
    const desktopPlaceholder = input.placeholder;
    function moveControls() {
      input.placeholder = mobile.matches ? input.dataset.mobilePlaceholder : desktopPlaceholder;
      if (!mobile.matches && dialog.open) dialog.close();
      if (mobile.matches && dialog.showModal) {
        root.querySelector('[data-fr-filter-slot]').append(controls);
        root.dataset.frMobileReady = 'true'; trigger.hidden = false;
      } else {
        controlsParent.append(controls); delete root.dataset.frMobileReady; trigger.hidden = true;
      }
      align();
    }
    let alignFrame;
    function align() {
      cancelAnimationFrame(alignFrame);
      alignFrame = requestAnimationFrame(() => {
        const rows = new Map();
        cards.forEach(({element}) => {
          ['.fr-title-row','.fr-inspired-row'].forEach(selector => element.querySelector(selector)?.style.removeProperty('min-height'));
          if (element.hidden) return;
          const top = Math.round(element.getBoundingClientRect().top);
          if (!rows.has(top)) rows.set(top, []);
          rows.get(top).push(element);
        });
        rows.forEach(elements => ['.fr-title-row','.fr-inspired-row'].forEach(selector => {
          const items = elements.map(el => el.querySelector(selector)).filter(Boolean);
          const height = Math.ceil(Math.max(0,...items.map(el => el.getBoundingClientRect().height)));
          items.forEach(el => {el.style.minHeight = height + 'px';});
        }));
      });
    }
    const values = () => Object.fromEntries(filters.map(select => [select.dataset.frResultsFilter,select.value]));
    function matchesFilter(product, choices, except = '') {
      const card = cards.get(product.handle);
      if (!card) return false;
      return Object.entries(choices).every(([key,value]) => {
        if (!value || key === except) return true;
        if (key === 'brand') return product.brand === value;
        if (key === 'gender') {
          const gender = normalise(product.gender);
          return gender === 'unisex' || (value === 'women' ? /women|female/.test(gender) : /^(men|male)$/.test(gender));
        }
        return key === 'character' ? card[key] === value : card[key].includes('|' + value + '|');
      });
    }
    function readURL() {
      const params = new URL(location.href).searchParams;
      input.value = params.get('q') || '';
      filters.forEach(select => {
        const value = params.get('fr_' + select.dataset.frResultsFilter) || '';
        select.value = Array.from(select.options).some(o => o.value === value) ? value : '';
      });
      sort.value = ['name','low','high'].includes(params.get('fr_sort')) ? params.get('fr_sort') : 'relevance';
    }
    function synchronise() {
      const url = new URL(location.href);
      const query = input.value.trim();
      if (query) url.searchParams.set('q',query); else url.searchParams.delete('q');
      filters.forEach(select => {
        const key = 'fr_' + select.dataset.frResultsFilter;
        if (select.value) url.searchParams.set(key,select.value); else url.searchParams.delete(key);
      });
      if (sort.value !== 'relevance') url.searchParams.set('fr_sort',sort.value); else url.searchParams.delete('fr_sort');
      url.searchParams.set('type','product'); url.searchParams.delete('page'); url.searchParams.delete('options[prefix]');
      if (url.href !== location.href) history.replaceState(history.state,'',url);
    }
    function reset() {
      input.value = ''; filters.forEach(select => {select.value = '';}); sort.value = 'relevance'; update();
    }
    function addChip(label, action) {
      const button = document.createElement('button'); button.type = 'button';
      button.setAttribute('aria-label',pageLabels.remove.replace('[filter]',label));
      const span = document.createElement('span'); span.textContent = label; button.append(span);
      button.insertAdjacentHTML('beforeend','<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m7 7 10 10M17 7 7 17"/></svg>');
      button.addEventListener('click',() => {action();update();input.focus({preventScroll:true});}); chips.append(button);
    }
    function update(sync = true) {
      const query = input.value.trim();
      const choices = values();
      const results = ranked(query).filter(({product}) => cards.has(product.handle));
      const matches = results.filter(({product}) => matchesFilter(product, choices));
      if (!query && sort.value === 'relevance') matches.sort((a,b) => Number(b.product.available) - Number(a.product.available) || Number(b.product.tags.some(t => /bestseller/i.test(t))) - Number(a.product.tags.some(t => /bestseller/i.test(t))) || a.product.title.localeCompare(b.product.title));
      if (sort.value === 'name') matches.sort((a,b) => a.product.title.localeCompare(b.product.title));
      if (sort.value === 'low') matches.sort((a,b) => a.product.price-b.product.price || a.product.title.localeCompare(b.product.title));
      if (sort.value === 'high') matches.sort((a,b) => b.product.price-a.product.price || a.product.title.localeCompare(b.product.title));
      cards.forEach(({element}) => {element.hidden = true;});
      matches.forEach(({product}) => {const {element} = cards.get(product.handle); element.hidden = false; grid.append(element);});
      filters.forEach(select => {
        select.classList.toggle('is-active',Boolean(select.value));
        Array.from(select.options).forEach(option => {
          if (option.value) option.disabled = option.value !== select.value && !results.some(({product}) => matchesFilter(product,{...choices,[select.dataset.frResultsFilter]:option.value}));
        });
      });
      const total = matches.length;
      count.textContent = (total === 1 ? pageLabels.one : pageLabels.many).replace('[count]',total) + (query ? ' ' + pageLabels.query.replace('[query]',query) : '');
      empty.hidden = total > 0;
      const active = Object.values(choices).filter(Boolean).length;
      root.querySelector('[data-fr-filter-count]').hidden = !active;
      root.querySelector('[data-fr-filter-count]').textContent = active;
      root.querySelector('[data-fr-query-clear]').hidden = !query;
      root.querySelector('[data-fr-results-clear]').hidden = !query && !active && sort.value === 'relevance';
      root.querySelector('[data-fr-search-suggestions]').hidden = Boolean(query || active);
      root.querySelector('[data-fr-refine-apply]').textContent = (total === 1 ? pageLabels.show_one : pageLabels.show).replace('[count]',total);
      chips.replaceChildren();
      filters.filter(select => select.value).forEach(select => addChip(select.selectedOptions[0].textContent,() => {select.value='';}));
      chips.hidden = !active;
      if (sync) synchronise();
      align();
      if (window.AOS) window.AOS.refreshHard();
    }
    form.addEventListener('submit',event => {event.preventDefault();update();});
    input.addEventListener('input',() => update()); input.addEventListener('search',() => update());
    input.addEventListener('keydown',event => {if(event.key === 'Escape' && input.value){event.preventDefault();input.value='';update();}});
    root.querySelector('[data-fr-query-clear]').addEventListener('click',() => {input.value='';update();input.focus();});
    [sort,...filters].forEach(select => select.addEventListener('change',() => update()));
    root.querySelector('[data-fr-results-clear]').addEventListener('click',() => {reset();input.focus();});
    root.querySelector('[data-fr-empty-reset]').addEventListener('click',() => {reset();input.focus();});
    root.querySelector('[data-fr-dialog-reset]').addEventListener('click',reset);
    root.querySelectorAll('[data-fr-search-term]').forEach(link => link.addEventListener('click',event => {event.preventDefault();input.value=link.dataset.frSearchTerm;update();input.focus();}));
    trigger.addEventListener('click',() => {
      const preview = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame');
      const rect = preview?.getBoundingClientRect();
      const offset = rect && rect.height>0 && rect.height<160 && rect.bottom>=innerHeight-1 ? Math.max(0,innerHeight-rect.top) : 0;
      dialog.style.setProperty('--fr-search-preview-offset',offset+'px');
      dialog.dataset.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden'; dialog.showModal();
    });
    root.querySelector('[data-fr-refine-close]').addEventListener('click',() => dialog.close());
    root.querySelector('[data-fr-refine-apply]').addEventListener('click',() => dialog.close());
    dialog.addEventListener('close',() => {document.body.style.overflow=dialog.dataset.previousOverflow || '';if(mobile.matches)trigger.focus({preventScroll:true});});
    dialog.addEventListener('click',event => {if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom)dialog.close();}});
    window.addEventListener('popstate',() => {readURL();update(false);});
    addEventListener('resize',align,{passive:true}); document.fonts?.ready.then(align);
    mobile.addEventListener('change',moveControls); moveControls(); readURL(); update(false);
  }
  function boot(){
    document.querySelectorAll('[data-fr-search-page]').forEach(setupResults);
    customElements.whenDefined('predictive-search').then(() => {
      document.querySelectorAll('predictive-search').forEach(component=>setupAutocomplete(component.querySelector('form'),component));
      document.querySelectorAll('.fr-mobile-search').forEach(form=>setupAutocomplete(form,null));
    });
  }
  boot();document.addEventListener('shopify:section:load',boot);
})();
